import $ from 'jquery'

if ($('#btn-back-to-top').length) {

	//Get the button
	let topbutton = document.getElementById("btn-back-to-top");

	// When the user scrolls down 20px from the top of the document, show the button
	window.onscroll = function() {
		scrollFunction();
	};

	function scrollFunction() {
		if (
			document.body.scrollTop > 20 ||
			document.documentElement.scrollTop > 20
		) {
			topbutton.style.display = "block";
		} else {
			topbutton.style.display = "none";
		}
	}
	// When the user clicks on the button, scroll to the top of the document
	topbutton.addEventListener("click", backToTop);

	function backToTop() {
		$( 'html, body' ).animate( {
			scrollTop: 0
		}, 250 );
	}

}
